import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import { MessageComposer } from "../../components/chatNewInterface/chatLayout/messageComposer/MessageComposer";

const generalSuggestions = [
  { text: "What's due this week?", color: "#e8ddfb", textColor: "#7244bb" },
  { text: "Help me study for my next quiz", color: "#d1e8eb", textColor: "#15727d" },
  { text: "When is the last day to withdraw?", color: "#cce6ff", textColor: "#0069cc" },
  { text: "Show me my upcoming assignments", color: "#fde8f0", textColor: "#c53469" },
];

const courseSuggestions = [
  { text: "What's due this week in this class?", color: "#e8ddfb", textColor: "#7244bb" },
  { text: "Explain this topic to me", color: "#d1e8eb", textColor: "#15727d" },
  { text: "Help me study for the next quiz", color: "#cce6ff", textColor: "#0069cc" },
  { text: "Summarize my latest assignment", color: "#fde8f0", textColor: "#c53469" },
];

const supportSuggestions = [
  { text: "When is the last day to withdraw?", color: "#e8ddfb", textColor: "#7244bb" },
  { text: "How do I apply for financial aid?", color: "#d1e8eb", textColor: "#15727d" },
  { text: "Where can I find tutoring services?", color: "#cce6ff", textColor: "#0069cc" },
  { text: "What are the add/drop deadlines?", color: "#fde8f0", textColor: "#c53469" },
];

interface ChatInputProps {
  value: string;
  onChangeText: (text: string) => void;
  onSubmit: () => void;

  disabled?: boolean;
  placeholder?: string;
  showSuggestions?: boolean;
  activeWorkspaceType: "general" | "course" | "support";

  // attachments (already computed)
  attachedTasks: any[];
  attachedAssignments: any[];
  attachedFiles: any[];

  // actions
  onAddTask: () => void;
  onAddAssignment: () => void;
  onAddFile: () => void;
  onRemoveAttachment: () => void;

  // modals
  taskModal: React.ReactNode;
  assignmentModal: React.ReactNode;
}
const ChatInput = ({
  value,
  onChangeText,
  onSubmit,
  disabled,
  placeholder,
  showSuggestions = true,
  activeWorkspaceType,

  attachedTasks,
  attachedAssignments,
  attachedFiles,

  onAddTask,
  onAddAssignment,
  onAddFile,
  onRemoveAttachment,

  taskModal,
  assignmentModal,
}: ChatInputProps) => {
  const suggestedPrompts = useMemo(() => {
    if (!showSuggestions) return [];
    return activeWorkspaceType === "general"
      ? generalSuggestions
      : activeWorkspaceType === "course"
        ? courseSuggestions
        : supportSuggestions;
  }, [showSuggestions, activeWorkspaceType]);

  return (
    <View style={styles.container}>
      <MessageComposer
        disabled={disabled}
        message={value}
        setMessage={onChangeText}
        onSendMessage={onSubmit}
        placeholder={placeholder}
        suggestedPrompts={suggestedPrompts}
        addTask={onAddTask}
        addAssignment={onAddAssignment}
        addFile={onAddFile}
        removeTask={onRemoveAttachment}
        removeAssignment={onRemoveAttachment}
        removeFile={onRemoveAttachment}
        attachedTasks={attachedTasks}
        attachedAssignments={attachedAssignments}
        attachedFiles={attachedFiles}
      />

      {taskModal}
      {assignmentModal}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    paddingVertical: 12,
    paddingHorizontal: 20,
  },
});

export default ChatInput;
